import React from 'react';

import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';

import { ClosureRequest, closureRequestStatuses } from '../types';
import { getReasonLabel } from './StartOrCancelClosureProcedure/FormContent';

export const ClosureRequestStatusTag = ({
  closureRequest,
}: {
  closureRequest: ClosureRequest | undefined | null;
}) => {
  if (!closureRequest) {
    return null;
  }

  const { status } = closureRequest;

  switch (status) {
    case closureRequestStatuses.Opened:
      const tooltipContent = (
        <div>
          <div>
            <strong>Reason:</strong> {getReasonLabel(closureRequest.reason)}
          </div>
          {closureRequest.details && (
            <div>
              <strong>Details:</strong> {closureRequest.details}
            </div>
          )}
        </div>
      );

      return (
        <Tooltip title={tooltipContent} placement="bottom">
          <Tag
            data-testid="tag-closure-pending"
            icon={<ExclamationCircleOutlined />}
            color="red"
            style={{ width: 'fit-content' }}
          >
            Closure pending
          </Tag>
        </Tooltip>
      );
    case closureRequestStatuses.Approved:
      return (
        <Tag
          data-testid="tag-closure-approved"
          icon={<ExclamationCircleOutlined />}
          color="red"
          style={{ width: 'fit-content' }}
        >
          Closed
        </Tag>
      );
    case closureRequestStatuses.Anonymized:
      return (
        <Tag
          data-testid="tag-closure-anonymized"
          icon={<ExclamationCircleOutlined />}
          color="orange"
          style={{ width: 'fit-content' }}
        >
          Anonymized
        </Tag>
      );
  }
};
